/* global flatpickr, rangePlugin: false */

import BurgerButton from './components/burger-button';
import MainMenu from './components/main-menu';
import Header from './components/header';
import ReadMoreToggler from './components/read-more-toggler';
import PhotoSwipeTheme from './components/photoswipe';
import SwiperSlider from './components/swiper-options';
import Animates from './components/gsap-animations';
// import MasonryOptions from './components/masonry-options';
// import FlickityOptions from './components/flickity-options';
import MasonryGallery from './components/masonry-gallery';
// import HeroVideo from './components/hero-video';
import ScrollToContent from '../../js/components/scroll-to-content';
import MouseHover from './components/mouse-hover';

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

const App = {
	init() {
		const burgerButton = new BurgerButton();
		const mainMenu = new MainMenu();
		const header = new Header();
		const scrollToContent = new ScrollToContent();

		//Swiper Slider
		const swiperSliders = document.querySelector('swiper-container');
		if (swiperSliders) {
			const swiperSliderElement = new SwiperSlider(swiperSliders);
		}
		// Array.from(document.querySelectorAll('#swiper-container')).map(el => new SwiperSlider(el));

		// $('.listing-posts-wrapper a[data-bs-toggle="tab"]').on('mouseenter', function () {
		// 	$(this).tab('show');
		// });

		// Photoswipe
		Array.from(document.querySelectorAll('.pswp-gallery')).map(el => new PhotoSwipeTheme(el));

		// Read More Toggler
		Array.from(document.querySelectorAll('.read-more-toggle-link')).map(el => new ReadMoreToggler(el));

		Array.from(document.querySelectorAll( '.gsap-animation' )).map(el => new Animates(el));

		//Element Filtering
		// [...document.querySelectorAll('.masonry-wrapper')].map(el => new MasonryOptions(el));

		//Flickity Options
		// [...document.querySelectorAll('.home .listing-posts-slideshow')].map(el => new FlickityOptions(el));

		// Masonry Gallery
		Array.from(document.querySelectorAll('.masonry-gallery')).map(el => new MasonryGallery(el));

		//Mouse Follower
		Array.from(document.querySelectorAll('.mouse-follower')).map(el => new MouseHover(el));

		//Close Youtube Videos on Modal Close
		Array.from(document.querySelectorAll('#video-gallery-wrapper .modal')).map(el => {
			el.addEventListener('hidden.bs.modal', function (e) {
				e.target.querySelector('iframe').setAttribute('src',e.target.querySelector('iframe').getAttribute('src'));
			});
		});

		// Datepicker Flatpickr
		class DatePicker {
			constructor(checkInEl = null, checkOutEl = null) {
				if ( checkInEl && checkOutEl) {
					this.checkInEl = checkInEl;
					this.checkOutEl = checkOutEl;

					flatpickr(this.checkInEl, {
						minDate: 'today',
						dateFormat: 'd-m-Y',
						plugins: [new rangePlugin({ input: checkOutEl})],
						disableMobile: 'true'
					});
				}
			}
		}
		let checkin = document.getElementById('checkin-picker');
		let checkout = document.getElementById('checkout-picker');

		if (checkin && checkout) {
			let checkinField = new DatePicker(checkin,checkout);
		}

		let observerOptions = {
			// threshold: [0, 1]
		};

		// Observer for fade-in-me effect
		const observerEffectFade = new IntersectionObserver((entries) => {
			entries.map((entry, index) => {
				if (entry.isIntersecting) {
					setTimeout(() => {
						entry.target.classList.add('is-in-view');
						observerEffectFade.unobserve(entry.target);
					}, 250 * index);
				}
			});
		}, observerOptions);
		document.querySelectorAll('.fade-in-me, .fade-over-me').forEach(observable => observerEffectFade.observe(observable));
	}
};

domLoaded(() => {
	App.init();
});
